// 👇️ ts-nocheck disables type checking for entire file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// 👇️ ts-ignore ignores any ts errors on the next line
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import registerServiceWorker from './registerServiceWorker'
import mqtt from './utils/mqtt'
import ErrorBoundary from './pages/ErrorBoundary/ErrorBoundary'
import { Spin } from 'antd'

//fetch master config
import fetchMasterConfig from './utils/fetchMasterConfig'
import { KioskModeProvider } from './contexts/KioskModeContext'
window.latestBuild = process?.env?.REACT_APP_LATEST_BUILD ? new Date(process?.env?.REACT_APP_LATEST_BUILD).toISOString() : null
window.Buffer = window.Buffer || require('buffer').Buffer
const MqttConnector = props => {
	// connect to mqtt broker over websocket
	const { REACT_APP_MQTT_URL, REACT_APP_MQTT_USERNAME, REACT_APP_MQTT_PASSWORD } = process?.env
	try {
		if (REACT_APP_MQTT_URL) {
			mqtt.connectToBroker(REACT_APP_MQTT_URL, {
				username: REACT_APP_MQTT_USERNAME,
				password: REACT_APP_MQTT_PASSWORD,
				port: 61619,
				reconnectPeriod: 5000,
			})
		}
	} catch (e) {}
	return props.children
}

//dynamically import App through lazy loading
const App = React.lazy(() => import('./App' /* webpackChunkName: "APP " */))
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
// fetchMasterConfig()
// root.render(
//   <React.StrictMode>
//     <MqttConnector>
//       <ErrorBoundary>
//         <Suspense
//           fallback={
//             //fallback UI till App is loaded
//             <div style={{ display: 'flex', justifyContent: 'center' }}>
//               <Spin size='large'></Spin>
//             </div>
//           }
//         >
//           <App />
//         </Suspense>
//       </ErrorBoundary>
//     </MqttConnector>
//   </React.StrictMode>
// )

fetchMasterConfig()
	.then(res => {
		root.render(
			<React.StrictMode>
				<MqttConnector>
					<ErrorBoundary>
						<Suspense
							fallback={
								//fallback UI till App is loaded
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<Spin size='large'></Spin>
								</div>
							}
						>
							<KioskModeProvider>
								<App />
							</KioskModeProvider>
						</Suspense>
					</ErrorBoundary>
				</MqttConnector>
			</React.StrictMode>,
			// document.getElementById('root'),
		)
	})
	.catch(e => {
		console.error(e)
	})
registerServiceWorker()
